export const NUM_ACTIVE_CHANNELS = 7;

export const NUM_ROWS_UPCOMING = 6;

export const NUM_ROWS_RELIVE = 1;
